/**
 * KAN-826: API of the client companies.
 *
 *   GET   /api/v1/client-companies/?search=&page=&page_size=  -> {count, results}
 *   GET   /api/v1/client-companies/<id>/                       -> company + contacts
 *   PATCH /api/v1/client-companies/<id>/                       -> requisites (400 with field errors)
 */
import apiClient from './client';
import type {
  ClientCompanyDetail,
  ClientCompanyListParams,
  ClientCompanyListResponse,
  ClientCompanyUpdatePayload,
} from '@/types/clientCompany';

const BASE = '/api/v1/client-companies/';

/** Query params of the list: an empty search is left out. */
function listQuery(params: ClientCompanyListParams): Record<string, string | number> {
  const query: Record<string, string | number> = {};
  const search = params.search?.trim();
  if (search) query.search = search;
  if (params.page) query.page = params.page;
  if (params.page_size) query.page_size = params.page_size;
  return query;
}

export const clientCompaniesApi = {
  list: async (params: ClientCompanyListParams): Promise<ClientCompanyListResponse> => {
    const { data } = await apiClient.get<ClientCompanyListResponse>(BASE, { params: listQuery(params) });
    return data;
  },

  get: async (id: string): Promise<ClientCompanyDetail> => {
    const { data } = await apiClient.get<ClientCompanyDetail>(`${BASE}${id}/`);
    return data;
  },

  update: async (id: string, payload: ClientCompanyUpdatePayload): Promise<ClientCompanyDetail> => {
    const { data } = await apiClient.patch<ClientCompanyDetail>(`${BASE}${id}/`, payload);
    return data;
  },
};
